import { inject, Injector, runInInjectionContext } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../guards/auth.service';
import { MessageHandlingService } from '../../service/message-handling.service';
import { SUPPRESS_API_TOAST } from './request-context';

export const requestInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const injector = inject(Injector);
  const router = inject(Router);

  const token = authService.getToken();
  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(request).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const messageHandler = injector.get(MessageHandlingService);
        messageHandler.handleSuccess(event, request.method, !request.context.get(SUPPRESS_API_TOAST));
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      const messageHandler = injector.get(MessageHandlingService);
      messageHandler.handleError(error, !request.context.get(SUPPRESS_API_TOAST));
      if (error.status === 401) {
        authService.logout();
        router.navigate(['/auth/login']);
      }
      if (error.status === 403) {
        router.navigate(['/access-denied']);
      }
      return throwError(() => error);
    })
  );
};
